import angular from 'angular';

import component from './manage-buttons.component';

const ManageButtons = angular
    .module('control-room.commons.basic.components.manage-buttons', [])
    .component('crManageButtons', component);

export default ManageButtons;
